<!--
 * @Author: natsu
 * @Date: 2020-03-31 17:32:31
 * @LastEditors: natsu
 * @LastEditTime: 2020-05-07 16:22:50
 * @Description: file content
 -->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>Additional</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/additional/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "release",
          linkList: [ur + "additional-zto.min.js"]
        },
        {
          label: "1.1.3",
          linkList: [ur + "1.1.3/additional-zto.min.js"]
        },
        {
          label: "1.1.2",
          linkList: [ur + "1.1.2/additional-zto.min.js"]
        },
        {
          label: "1.1.1",
          linkList: [ur + "1.1.1/additional-zto.min.js"]
        },
        {
          label: "1.1.0",
          linkList: [ur + "1.1.0/additional-zto.min.js"]
        },
        {
          label: "1.0.9",
          linkList: [ur + "1.0.9/additional-zto.min.js"]
        },
        {
          label: "1.0.8",
          linkList: [ur + "1.0.8/additional-zto.min.js"]
        },
        {
          label: "1.0.7",
          linkList: [ur + "1.0.7/additional-zto.min.js"]
        },
        {
          label: "1.0.6",
          linkList: [ur + "1.0.6/additional-zto.min.js"]
        },
        {
          label: "1.0.5",
          linkList: [ur + "1.0.5/additional-zto.min.js"]
        },
        {
          label: "1.0.4",
          linkList: [ur + "1.0.4/additional-zto.min.js"]
        },
        {
          label: "1.0.3",
          linkList: [ur + "1.0.3/additional-zto.min.js"]
        },
        {
          label: "1.0.2",
          linkList: [ur + "1.0.2/additional-zto.min.js"]
        },
        {
          label: "1.0.1",
          linkList: [ur + "1.0.1/additional-zto.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListAdditional.vue